define('modules/start/products/trans/activity/view',['require','exports','module','env','views/BaseView','ldsh!./template'],function(require, exports, module) {
    "use strict";

    var Config = require("env");
    var BaseView = require("views/BaseView");

    var Layout = BaseView.extend({
        template: require("ldsh!./template"),
        serialize: function() {
            return {
                "trans_sendings": this.productsReport.get("trans_sendings"),
                "trans_deliveries": this.productsReport.get("trans_deliveries"),
                "trans_openings": this.productsReport.get("trans_openings"),
                "trans_failed": this.productsReport.get("trans_failed"),
                isAdm: this.isAdm
            };
        }
    });

    module.exports = Layout;
});

